// extracted by mini-css-extract-plugin
export default {"wrapper":"src_wrapper__SK4kg","card":"src_card__-KW78","title":"src_title__lvO+I","advice":"src_advice__6FYg1","dice_icon":"src_dice_icon__qThpT","divider":"src_divider__q8gId"};